import styled from 'styled-components';
import RedScreenLayout from '../components/RedScreenLayout';
import DownloadApp from '../components/DownloadApp';
import TermsModal from '../components/TermsModal';
import { useState } from 'react';
import { offerFootnote } from '../offer';

const Heading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 40px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;
  margin: 32px 24px 16px;
`;

const SubText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 0 auto 16px;
  width: 328px;
`;

const InfoText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 12px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 0 auto 40px;
  width: 328px;
  opacity: 0.7;
`;

function PreCampaign({ offer }) {
  const [showTerms, setShowTerms] = useState(false);

  const handleTcsClick = () => {
    setShowTerms(true);
    window.gtag('event', 'mm-early-btn-tcs');
  };

  return (
    <RedScreenLayout>
      <Heading>
        We haven’t <br />
        kicked-off yet!
      </Heading>
      <SubText>Stay tuned to claim your Big Mac&reg;.</SubText>
      <InfoText>
        {offerFootnote(offer)}{' '}
        <span onClick={handleTcsClick} style={{ textDecoration: 'underline' }}>
          Terms & Conditions apply
        </span>
      </InfoText>
      <DownloadApp page="pre-campaign" />
      {showTerms && <TermsModal offer={offer} onClose={() => setShowTerms(false)} />}
    </RedScreenLayout>
  );
}
export default PreCampaign;
